module.exports = __webpack_public_path__ + "static/img/go2.c4c1fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/go2.png
// module id = Yzw8
// module chunks = 0